import { handleParams, joinParams } from '../utils'

export default {

  /**
   * 门锁列表
   * @param page
   * @param size
   * @param orderBy 排序依赖  custRoomNo
   * @param search
   * @param sort desc 排序
   * @param hotspotPowerIds
   * @param filter {"chainId":224,"custRoomNo":"4000no普通标间23"}
   * @param filter -> isLowBattery 电量状态 0 正常 1 低电量
   * @param filter -> chainId 门店id
   * @param filter -> custRoomNo  房间号
   * @param filter -> lockNetworkState 网络状态 0 离线 1 在线
   * @param filter -> flag 售卖状态 1: '销售中',2: '已删除',3: '已下架',4: '筹建中',5: '售前展示',
   * @param filter -> stat 启用状态 0停用 1启用
   * @param filter -> lockModelId 门锁型号
   */
  queryAllRock(params) {
    return this.instance.get('/v2/lockApi/queryAllRock.do', {
      params: handleParams(params)
    })
  },

  /**
   * 门锁型号列表
   */
  queryAllRockModel() {
    return this.instance.get('/lockApi/queryAllRockModel.do', {
      params: {
        json_data: {}
      }
    })
  },

  /**
   * 通电列表
   */
  queryAllElecList(params) {
    return this.instance.get('/api/weiKong/selectElectricity', {
      params: handleParams(params)
    })
  },

  /**
   * 通电申请
   */
  applyElecList(params) {
    return this.instance.post('/api/weiKong/applyElectricity', { ...params } )
  },

  /**
   * 获取开门记录
   * @param {*} page 
   * @param {*} size 
   * @param {*} filter 
   * @param {*} filter -> beginDate 
   * @param {*} filter -> endDate 
   * @param {*} filter -> lockId 锁id
   * @param {*} filter -> openType 开门类型
   * @param {*} filter -> status 开门状态
   * @param {*} filter -> handlerName 开门人 
   */
  getLockOpenLog(params) {
    return this.instance.get('/lockApi/getLockOpenLogNew.do', {
      params: handleParams(params)
    })
  },

  /**
   * 更换门锁
   */
  changeLock(params) {
    return this.instance.post('/lockApi/changeLock.do', joinParams({json_data: JSON.stringify(params)}))
  },
  /**
   * 获取密码记录
   * @param {*} lockId 
   */
  getLockPwdInfo(params) {
    return this.instance.post('/lockApi/getLockPwdInfo.do', joinParams({json_data: JSON.stringify(params)}))
  },

  /**
   * 重置门锁即时密码
   * @param {*} pwdId 
   * @param {*} handlerName 
   */
  resetRealTimePwd(params) {
    return this.instance.post('/lockApi/resetRealTimePwd.do', joinParams({json_data: JSON.stringify(params)}))
  },

  /**
   * 重置门锁客户密码
   * @param {*} pwdId 
   * @param {*} handlerName 
   */
  resetCustomerPwd(params) {
    return this.instance.post('/lockApi/resetCustomerPwd.do', joinParams({json_data: JSON.stringify(params)}))
  },

  /**
   * 重置门锁超级密码
   * @param {*} pwdId 
   * @param {*} handlerName 
   */
  resetSuperPwd(params) {
    return this.instance.post('/lockApi/resetSuperPwd.do', joinParams({json_data: JSON.stringify(params)}))
  },

  /**
   * 重置门锁长租密码
   * @param {*} pwdId 
   * @param {*} handlerName 
   */
  resetLongRentPwd(params) {
    return this.instance.post('/lockApi/resetLongRentPwd.do', joinParams({json_data: JSON.stringify(params)}))
  },

  /**
   * 新增单次密码
   * @param endTime
   * @param isMaster 是否主锁（允许为空）
   * @param lockId
   * @param pwdType 1客人密码 2管家密码 3超级密码 4长租密码 5即时密码['','super','lrpwd','realtime']
   * @param remark
   * @param roomId
   * @param sn
   * @param startTime YYYY-MM-DD HH:mm:ss
   * @param writeTime
   */
  setRealTimePwd(params) {
    return this.instance.post('/lockApi/setRealTimePwd.do', joinParams({json_data: JSON.stringify(params)}))
  },

  /**
   * 设置门锁离线密码
   * @param {*} durationMs: number;
   * @param lockId: number;
   * @param operatorUserName: string;
   * @param remark: string; 
   */
  addOfflinePwd(params) {
    return this.instance.post('/lockApi/addOfflinePwd/byDuration', joinParams({json_data: JSON.stringify(params)}))
  },

  /**
   * 新增长租门锁密码
   * @param endTime
   * @param isMaster 是否主锁（允许为空）
   * @param lockId
   * @param pwdType 1客人密码 2管家密码 3超级密码 4长租密码 5即时密码['','super','lrpwd','realtime']
   * @param remark
   * @param roomId
   * @param sn
   * @param startTime YYYY-MM-DD HH:mm:ss
   * @param writeTime  
   */
  addLongRentPwd(params) {
    return this.instance.post('/lockApi/addLongRentPwd.do', joinParams({json_data: JSON.stringify(params)}))
  },

  /**
   * 更新门锁状态
   * @param {*} lockId 
   */
  updateLockState(params) {
    return this.instance.post('/lockApi/updateLockState.do', joinParams({json_data: JSON.stringify(params)}))
  },

  /**
   * 远程开门
   * @param {*} lockId 
   */
  openRoomLock(params) {
    return this.instance.post('/lockApi/openRoomLock.do', joinParams({json_data: JSON.stringify(params)}))
  },

  /**
   * 基础管理-门店信息列表
   * @param {*} chainName 门店名称
   * @param {*} pageSize 每页显示数量
   * @param {*} chainType 门店类型
   * @param {*} pageNum 当前页
   * @param {*} chainId 门店ID
   * @param {*} city 城市
   * @param {*} hotspotPowerIds 门店权限ID
   * @param {*} beginDate 2018-09-01, 开始时间
   * @param {*} province , 省份
   * @param {*} mainPerson , 主要负责人
   * @param {*} endDate 2018-10-22, 结束时间
   */
  getRoomChain(params) {
    return this.instance.get('/roomChain/searchChain', {
      params: handleParams(params)
    })
  },

  /**
   * 修改门店信息 下面参数都必传
   * @param {*} chainId 门店ID，必传
   * @param {*} chainName 门店名称
   * @param {*} contactPhone , 门店电话
   * @param {*} address 门店地址
   * @param {*} remind 特别提醒
   * @param {*} chainType 类型 0分散 1聚集
   * @param {*} mainPerson 门店负责人
   * @param {*} mainPhone 负责人电话
   * @param {*} province 省
   * @param {*} city 市
   * @param {*} district 街道
   * @param {*} tradingArea 商圈
   */
  updateChainInfo(params) {
    return this.instance.put('/roomInfo/chain', joinParams(params))
  },

  /**
   * 房间基础信息
   * @param {*} roomId 
   */
  getRoomInfo(params) {
    return this.instance.get('/roomInfo/room', {
      params: params
    })
  },

  /**
   * 房间基础信息修改
   * @param {*} roomId 
   * @param {*} roomFloor 
   * @param {*} hasLock 
   * @param {*} tagList { rentType: [{tagType: 'ROOM', tagValue: 11, checked: true, tagCode: 22, cnameWay: 11}]}
   * @param {*} roomGuarantee 
   * @param {*} updateUserName 
   * @param {*} updateUserId 
   * @param {*} isPresale 
   * @param {*} shortGuarentee 
   * @param {*} custRoomName 
   * @param {*} custRoomNo 
   */
  updateRoomInfo(params) {
    return this.instance.post('/roomInfo/updateRoomBase.do', joinParams({json_data: JSON.stringify(params)}))
  },

  /**
   * 获取房间描述信息
   * @param {*} roomId 
   */
  getRoomTxt(params) {
    return this.instance.get('/RoomTxt/roomId', {
      params: params
    })
  },

  /**
   * 更新房间描述信息
   * @param GUIDE 寻房指引
   * @param REMIND 特别提醒
   * @param NOTICE 入住须知
   * @param FEATURE 房间特色
   * @param OTANOTICE 房源基本概要
   * @param roomId 
   */
  updateRoomTxt(params) {
    return this.instance.post('/RoomTxt/more', joinParams({json_data: encodeURIComponent(JSON.stringify(params))}))
  },

  /**
   * 房间图片
   * @param {*} roomId 
   * @param {*} start 
   * @param {*} size 
   */
  getRoomFlack(params) {
    return this.instance.get('/roomInfo/queryRoomFlack.do', {
      params: {json_data: JSON.stringify(params)}
    })
  },

  /**
   * 房间图片编辑
   * @param {*} flackId 
   * @param {*} flackType ROOMCOVER设置为封面
   */
  updateRoomFlack(params) {
    return this.instance.post('/roomInfo/updateRoomFlack.do', joinParams({json_data: JSON.stringify(params)}))
  },

  /**
   * 图片排序
   * @param {*} id flackId 
   * @param {*} id sn index 
   */
  updateRoomFlackSn(params) {
    return this.instance.post('/roomInfo/updateRoomFlackSn.do', joinParams({json_data: JSON.stringify(params)}))
  },

  /**
   * 删除房间图片
   * @param {*} id 
   */
  deleteRoomFlack(params) {
    return this.instance.post('/roomInfo/removeRoomFlack.do', joinParams({json_data: JSON.stringify(params)}))
  },

  /**
   * 批量删除图片
   * @param ids 多个id使用,号分隔, 图片(素材)id
   */
  batchRemoveRoomFlack(params) {
    return this.instance.post('/roomInfo/listRemoveRoomFlack', joinParams(params))
  },

  /**
   * 获取其他房间
   * @param {*} roomId 当前房间
   * @param {*} keyword 模糊搜索 
   */
  getOtherRooms(params) {
    return this.instance.get('/roomInfo/copyPicture/searchOtherRooms/all', {
      params: handleParams(params)
    })
  },

  /**
   * 复制图片到指定房间
   * @param sourceRoomId @mock=507, 要复制的图片素材 源房间id
   * @param listTargetRoomId @mock="[111,22,33,44]", 复制图片的目标房间Id json数组
   */
  copyPictureToRooms(params) {
    return this.instance.post('/roomInfo/copyPicture/toRooms', joinParams(params))
  },

  /**
   * 添加房间图片
   * @param {*} roomId 
   * @param {*} flackType ROOMCAROUSEL 
   * @param {*} title  
   * @param {*} sn  describeId
   * @param {*} describeId 七牛返回id res.materialBase.id,
   * @param {*} url 七牛返回url res.materialBase.url,
   * @param {*} remark 七牛返回url res.materialBase.remark,
   */
  addRoomFlack(params) {
    return this.instance.post('/roomInfo/addRoomFlack.do', joinParams({json_data: JSON.stringify(params)}))
  },

  /**
   * 修改门店房型信息
   * @param room_type_id id
   * @param name 房型名称
   * @param operator 操作人
   * @param status 
   */
  updateRoomTypeInfo(params) {
    return this.instance.post('/api/v1/room_types/update', joinParams(params))
  },

  /**
   * 修改房间所属房型
   * @param room_type_id 更换的房型id
   * @param changed_room_type_id 被更换的房型ID
   * @param operator 操作人
   * @param xbed_room_id xbed房间id
   */
  changRoomType(params) {
    return this.instance.post('/api/v1/room_types/change', joinParams(params))
  },

  /**
   * 钟点房配置 创建更新 (废弃)
   * @param {*} chainId 门店id 
   * @param {*} hourRoomSwitch 钟点房开关 1开 0关
   * @param {*} timeRange 钟点房时长
   * @param {*} price 钟点房价格
   * @param {*} updateName 更新人
   */
  updateHourRoom(params) {
    return this.instance.post('/api/hourRoom', joinParams(params))
  },

  /**
   * 钟点房查询 (废弃)
   * @param {*} chainId 门店id 
   */
  getHourRoom(params) {
    return this.instance.get('/api/hourRoom/chain', {
      params: params
    })
  },

  /**
   * 批量设置房型钟点房配置
   * @param {*} operator 操作人
   * @param {Array} room_types  房型列表
   * @param {*} room_types room_type_id 房型ID
   * @param {*} room_types  name 门店房型名称
   * @param {*} room_types  description 房型描述
   * @param {*} room_types  hourly_begin_at 钟点房开始时间
   * @param {*} room_types  hourly_end_at 钟点房结束时间
   * @param {*} room_types  hourly 钟点时长
   * @param {*} room_types  hourly_price 钟点价格，单位分
   * @param {*} room_types  has_hourly 是否支持钟点 0 否 1是
   * @param {*} room_types  status 房型状态： 1上线 0下架
   */
  batchUpdateHourConfig(params) {
    return this.instance.post('/api/v1/room_types/batch_update', joinParams(params))
  },

  /**
   * 获取房型钟点信息 参数都为选填
   * @param {*} xbed_room_type_id xbedOTA打包房型ID
   * @param {*} hotel_id 关联门店id
   * @param {*} xbed_hotel_id xbed hotel
   * @param {*} hotel_name 酒店名称
   * @param {*} room_type_id 房型ID
   * @param {*} room_type_ids 房型ID array
   * @param {*} room_type_name 房型名称
   * @param {*} room_type_type (必传) 房型种类 hotel，homestay，all
   * @param {*} room_id 房间id
   * @param {*} room_ids 房间id array
   * @param {*} xbed_room_id 
   * @param {*} room_no 房间号
   * @param {*} room_name 房间名称
   * @param {*} room_floor 所在楼层
   * @param {*} room_no_order 房间号排序 desc
   */
  getRoomTypeHourConfig(params) {
    return this.instance.get('/api/v1/room_types/show', {
      params: params
    })
  }
}


// WEBPACK FOOTER //
// ./src/api/basesetting.js